import * as React from 'react'
import { ContactUsSideBar } from './ContactUsSideBar'
import { Container } from '../Container'
import { ContactUsForm } from '../Forms/ContactUsForm'

export const ContactUsFormSection: React.FC = () => {
  return (
    <section>
      <Container>
        <div className="grid md:grid-cols-12 gap-4">
          <div className="col-span-4">
            <ContactUsSideBar />
          </div>
          <div className="col-span-8">
            <ContactUsForm />
          </div>
        </div>
      </Container>
    </section>
  )
}
